export default __webpack_public_path__ + "static/media/Sliders-Home-04-1.c2701296.webp";